<template>
  <div class="party-page">
    <!-- 页面标题 -->
    <section class="page-banner party-banner">
      <!-- 数量为1时，显示单张图片 -->
      <div v-if="bannerSlides.length === 1" class="banner-single-bg">
        <img :src="bannerSlides[0].carouselUrl" class="bg-img">
      </div>

      <!-- 数量大于1时，显示轮播幻灯片 -->
      <div v-else-if="bannerSlides.length > 1" class="banner-slider-bg">
        <div v-for="(slide, idx) in bannerSlides" :key="idx" class="bg-slide" :class="{ active: currentBanner === idx }">
          <img :src="slide.carouselUrl" class="bg-img">
        </div>
      </div>

      <div class="container">
        <h1>企业党建</h1>
        <el-breadcrumb separator="/" class="breadcrumb">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>企业党建</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </section>

    <!-- 固顶导航锚点包装 -->
    <div ref="partyNavAnchor" class="nav-anchor-wrapper" :style="{ height: isNavFixed ? navHeight + 'px' : 'auto' }">
      <!-- 热区导航 -->
      <nav class="party-nav" :class="{ fixed: isNavFixed }" ref="partyNav">
        <div class="container nav-box">
          <a 
            v-for="(menu, index) in menuList" 
            :key="menu.id" 
            href="javascript:;" 
            class="nav-hotspot" 
            :class="{ active: activeSection === menu.sectionId || (index === 0 && !activeSection) }" 
            @click="handleMenuClick(menu)"
          >
            <i :class="getMenuIcon(menu.name)"></i> {{ menu.name }}
          </a>
        </div>
      </nav>
    </div>

    <!-- 党建概况 -->
    <section id="overview" class="party-section bg-light">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">党建概况</h2>
        </div>
        <div class="party-overview">
          <div class="overview-content">
            <div v-if="dangjiangaikuang" v-html="dangjiangaikuang.value"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- 党建动态 -->
    <section id="dynamics" class="party-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">党建动态</h2>
          <router-link :to="{ path: '/party/list', query: { id: pcode, tab: getTabTplBySection('dynamics') } }" class="view-more">查看更多 <i class="el-icon-right"></i></router-link>
        </div>
        <div class="dynamics-grid">
          <router-link :title="newsData[0].title" class="dynamic-card featured" v-if="newsData != null && newsData.length > 0" :to="{ path: '/news/detail', query: { id: newsData[0].id, from: 'party' } }" target="_blank">
            <div class="dynamic-image">
               <img :src="newsData[0].ico" style="width: 100%; height: 100%; object-fit: cover;"
                :defaultimg="newsData[0].defaultImg"/>
            </div>
            <div class="dynamic-content">
              <h4>{{ newsData[0].title }}</h4>
              <p>{{ newsData[0].description }}</p>
              <div class="dynamic-meta">
                <span><i class="el-icon-date"></i> {{ newsData[0].date }}</span>
                <span v-if="$store.state.siteConfig.showVisits === '1'"><i class="el-icon-view"></i> {{ newsData[0].visits }}</span>
              </div>
            </div>
          </router-link >
          <div class="dynamic-list">
            <div class="dynamic-item" v-for="(news, index) in newsData" :key="index" v-if="index >= 1">
              <div class="dynamic-date">
                <span class="day">{{ formatDateParts(news.date).day }}</span>
                <span class="month">{{ formatDateParts(news.date).month }}</span>
              </div>
              <div class="dynamic-info">
                <h5><router-link :title="news.title" :to="{ path: '/news/detail', query: { id: news.id, from: 'party' } }" :style="{color: news.titlecolor != '' ? news.titlecolor:'#333333'}" target="_blank">{{news.title}}</router-link></h5>
                <p>{{news.description}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 群团工会 -->
    <section id="union" class="party-section bg-light">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">群团工会</h2>
          <router-link :to="{ path: '/party/list', query: { id: pcode, tab: getTabTplBySection('union') } }" class="view-more">查看更多 <i class="el-icon-right"></i></router-link>
        </div>
        <div class="union-new-grid">
          <router-link 
            :title="item.title"
            v-for="(item, index) in unionData.slice(0, 6)" 
            :key="index" 
            :to="{ path: '/news/detail', query: { id: item.id, from: 'party' } }"
            target="_blank"
            class="union-card"
          >
            <div class="union-card-image">
              <img :src="item.ico" alt="union image"  :defaultimg="item.defaultImg">
            </div>
            <div class="union-card-content">
              <h4 :style="{color: item.titlecolor != '' ? item.titlecolor : '#333'}">{{ item.title }}</h4>
              <div class="union-card-divider"></div>
              <p class="union-summary">{{ item.description }}</p>
              <div class="union-meta">
                <span class="union-date">{{ item.date }}</span>
              </div>
            </div>
            <!-- Hover Overlay moved to card level -->
            <div class="union-overlay">
              <span class="btn-detail">查看详情</span>
            </div>
          </router-link>
        </div>
      </div>
    </section>

    <!-- 党建专题 -->
    <section id="topics" class="party-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">党建专题</h2>
        </div>
        <div class="topics-grid" v-if="djztData.length <= 3">
          <a v-for="(item, i) in djztData" :key="i" :href="item.targetUrl" target="_blank" class="topic-card">
            <img :src="item.carouselUrl" class="topic-img" :defaultimg="item.defaultImg" />
            <h4>{{ item.title }}</h4>
          </a>
        </div>
        <div class="topics-continuous-wrap" v-else>
           <div class="topics-continuous-list">
              <div class="scoll-group">
                 <a v-for="(item, i) in djztData" :key="'g1-'+i" :href="item.targetUrl" target="_blank" class="topic-card">
                    <img  :src="item.carouselUrl" class="topic-img"  :defaultimg="item.defaultImg" />
                    <h4>{{ item.title }}</h4>
                 </a>
              </div>
              <div class="scoll-group">
                 <a v-for="(item, i) in djztData" :key="'g2-'+i" :href="item.targetUrl" target="_blank" class="topic-card">
                    <img :src="item.carouselUrl" class="topic-img" :defaultimg="item.defaultImg"/>
                    <h4>{{ item.title }}</h4>
                 </a>
              </div>
           </div>
        </div>
      </div>
    </section>

    <!-- 党规党章 -->
    <section id="rules" class="party-section bg-light">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">党规党章</h2>
          <router-link :to="{ path: '/party/list', query: { id: pcode, tab: getTabTplBySection('rules') } }" class="view-more">查看更多 <i class="el-icon-right"></i></router-link>
        </div>
        <div class="rules-grid">
          <div class="rule-card" v-for="(rule, index) in rulesData" :key="index">
            <div class="rule-icon">
              <i class="el-icon-s-flag"></i>
            </div>
            <div class="rule-content">
              <h4 :style="{color: rule.titlecolor != '' ? rule.titlecolor:'#333333'}">{{ rule.title }}</h4>
              <p>{{ rule.description }}</p>
              <router-link :title="rule.title" :to="{ path: '/news/detail', query: { id: rule.id, from: 'party' } }" target="_blank" class="btn-rule-view">点击查看</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 廉洁资管 -->
    <section id="integrity" class="party-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">廉洁资管</h2>
          <router-link :to="{ path: '/party/list', query: { id: pcode, tab: getTabTplBySection('integrity') } }" class="view-more">查看更多 <i class="el-icon-right"></i></router-link>
        </div>
        <div class="integrity-grid">
          <div class="integrity-card" v-for="(item, index) in integrityData" :key="index">
            <div class="integrity-card-content">
              <h4><router-link :title="item.title" :to="{ path: '/news/detail', query: { id: item.id, from: 'party' } }" target="_blank" :style="{color: item.titlecolor != '' ? item.titlecolor:'#333333'}">{{ item.title }}</router-link></h4>
              <p>{{ item.description }}</p>
            </div>
            <div class="integrity-card-meta">
              <span class="date">{{ item.date }}</span>
              <span class="views" v-if="$store.state.siteConfig.showVisits === '1'"><i class="el-icon-view"></i> {{ item.visits }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系信息 -->
    <section id="contact" class="party-section bg-light">
      <div class="container">
        <div class="contact-grid">
          <div class="contact-card">
            <h3>来信请寄</h3>
            <div class="contact-value"  v-if="lxqj" v-html="lxqj.value"></div>
          </div>
          <div class="contact-card">
            <h3>监督电话</h3>
            <div class="contact-value" v-if="jddh">{{ jddh.value }}</div>
          </div>
          <div class="contact-card">
            <h3>监督邮箱</h3>
            <div class="contact-value">{{ $store.state.siteConfig.showEmail}}</div>
          </div>
        </div>
      </div>
    </section>



  </div>
</template>

<script>
import { getSubMenuList, getNewsList, getBannerList, getLabelList } from '@/api/menu'

export default {
  name: 'Party',
  data() {
    return {
      bannerSlides: [],
      currentBanner: 0,
      bannerTimer: null,
      activeSection: null,
      menuList: [],
      pcode: this.$route.query.id, 
      isNavFixed: false,
      navOffsetTop: 0,
      navHeight: 0,
      newsData: [],
      rulesData: [],
      integrityData: [],
      unionData: [],
      dangjiangaikuang: null,
      djztData:[],
      lxqj: "",
      jddh: ""
    }
  },
  watch: {
    '$route.query.id': {
      handler(newId) {
        if (newId) {
          this.pcode = newId
          this.fetchSubMenus()
        }
      },
      immediate: false
    }
  },
  created() {
    this.fetchBanner("qydj");
    this.fetchSubMenus();
    this.fetchLabel("dangjiangaikuang");
    this.fetchBanner("djzt");
    this.fetchLabel("jddh");
    this.fetchLabel("lxqj");
  },
  mounted() {
    this.startBannerTimer();
    this.$nextTick(() => {
      if (this.$refs.partyNav) {
        this.navOffsetTop = this.$refs.partyNav.offsetTop;
      }
      window.addEventListener('scroll', this.handleScroll);
    });
  },
  beforeDestroy() {
    if (this.bannerTimer) {
      clearInterval(this.bannerTimer);
    }
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    async fetchLabel(name) {
      try {
        const res = await getLabelList({ name })
        if (res.code === 0) {
          if (name == 'dangjiangaikuang') {
            this.dangjiangaikuang = res.data
          } else if (name == 'companyHistory') {
            this.companyHistory = res.data
          } else if (name == 'jddh') {
            this.jddh = res.data;
          } else if(name == 'lxqj') {
            this.lxqj = res.data;
          }
          
        } 
      } catch (error) {
        console.error('获取轮播图失败', error)
      }
    },
    startBannerTimer() {
      this.bannerTimer = setInterval(() => {
        if (this.bannerSlides.length > 1) {
          this.currentBanner = (this.currentBanner + 1) % this.bannerSlides.length;
        }
      }, 4000);
    },
    async fetchBanner(groupCode) {
      try {
        const res = await getBannerList({ groupCode })
        if (res.code === 0) {
          if (groupCode == 'djzt') {
            this.djztData = res.rows || []
          } else {
            this.bannerSlides = res.rows || []
          }
        } 
      } catch (error) {
        console.error('获取轮播图失败', error)
      }
    },
    formatDateParts(dateString) {
      // 处理空值
      if (!dateString) return { day: '', month: '' };
      
      try {
        // 统一处理方法：提取日期部分（第一个连续的数字组合）
        // 匹配格式：2022-08-24 或 2022-08-24 23:05:33
        const dateMatch = dateString.match(/(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
        
        if (dateMatch) {
          const year = dateMatch[1];
          const month = dateMatch[2].padStart(2, '0');
          const day = dateMatch[3].padStart(2, '0');
          
          return {
            day: day,
            month: month + '月'
          };
        }
        
        // 如果匹配失败，尝试用传统方法
        const datePart = dateString.split(' ')[0];
        const parts = datePart.split(/[-/]/);
        
        if (parts.length === 3) {
          const month = parts[1].padStart(2, '0');
          const day = parts[2].padStart(2, '0');
          
          return {
            day: day,
            month: month + '月'
          };
        }
        
        console.warn('Invalid date format:', dateString);
        return { day: '', month: '' };
        
      } catch (error) {
        console.error('Error formatting date:', error);
        return { day: '', month: '' };
      }
    },
    async fetchSubMenus() {
      try {
        const res = await getSubMenuList(this.pcode)
        if (res.code === 0) {
          this.menuList = (res.rows || []).map(item => {
            let sectionId = '';
            if (item.contenttpl === 'sys_content_type_news_05' || item.name.includes('动态')) sectionId = 'dynamics';
            else if (item.contenttpl === 'sys_content_type_news_06' || item.name.includes('党规') || item.name.includes('党章')) sectionId = 'rules';
            else if (item.contenttpl === 'sys_content_type_news_07' || item.name.includes('廉洁')) sectionId = 'integrity';
            else if (item.name.includes('概况')) sectionId = 'overview';
            else if (item.name.includes('专题')) sectionId = 'topics';
            else if (item.name.includes('群团') || item.name.includes('工会')) sectionId = 'union';
            return { ...item, sectionId };
          });

          if (this.menuList.length > 0) {
            if (!this.activeSection) {
              this.activeSection = this.menuList[0].sectionId;
            }
            for (let i = 0; i < this.menuList.length; i++) {
              if (this.menuList[i].contenttpl) {
                this.fetchNews(this.menuList[i]);
              }
            }
          }
        }
      } catch (error) {
        console.error('获取企业党建二级菜单失败', error)
      }
    },
    async fetchNews(menuItem) {
      try {
        const sys_content_type = menuItem.contenttpl;
        let pageSize = 6;
        if (menuItem.sectionId == 'dynamics') {
           pageSize = 5;
        } else if (menuItem.sectionId == 'union') {
           pageSize = 6;
        }
        const res = await getNewsList({
          info_type: sys_content_type,
          keyword: '',
          pageNum: 1,
          pageSize: pageSize
        })
        if (res.code === 0) {
          if (menuItem.sectionId == 'dynamics') {
            this.newsData = res.rows || []
          } else if (menuItem.sectionId == 'rules') {
            this.rulesData = res.rows || []
          } else if (menuItem.sectionId == 'integrity') {
            this.integrityData = res.rows || []
          } else if (menuItem.sectionId == 'union') {
            this.unionData = res.rows || []
          }
        }
      } catch (error) {
        console.error('获取列表失败', error)
      }
    },
    handleMenuClick(menu) {
      if (menu.sectionId) {
        this.scrollTo(menu.sectionId);
      }
    },
    handleScroll() {
      const anchor = this.$refs.partyNavAnchor;
      const navItem = this.$refs.partyNav;
      if (!anchor) return;

      if (navItem && !this.navHeight) {
        this.navHeight = navItem.offsetHeight;
      }

      const rect = anchor.getBoundingClientRect();
      this.isNavFixed = rect.top <= 0;

      const scrollY = window.pageYOffset;
      // Scroll Spy Logic
      const sections = ['overview', 'dynamics', 'union', 'topics', 'rules', 'integrity'];
      for (const section of sections) {
        const el = document.getElementById(section);
        if (el) {
          // Add offset to compensate for fixed nav height
          if (scrollY >= el.offsetTop - 120 && scrollY < el.offsetTop + el.offsetHeight - 120) {
            this.activeSection = section;
          }
        }
      }
    },
    getMenuIcon(name) {
      if (!name) return 'el-icon-s-flag';
      if (name.includes('概况')) return 'el-icon-s-flag';
      if (name.includes('动态')) return 'el-icon-document';
      if (name.includes('专题')) return 'el-icon-collection-tag';
      if (name.includes('党规')) return 'el-icon-connection';
      if (name.includes('廉洁')) return 'el-icon-circle-check';
      if (name.includes('群团') || name.includes('工会')) return 'el-icon-coordinate';
      return 'el-icon-s-flag';
    },
    scrollTo(id) {
      const el = document.getElementById(id);
      if (el) {
        this.activeSection = id; // trigger class instantly
        const offset = 90; // Fixed Nav offset
        window.scrollTo({
          top: el.offsetTop - offset,
          behavior: 'smooth'
        });
      }
    },
    getTabTplBySection(sectionId) {
      const found = this.menuList.find(m => m.sectionId === sectionId);
      return found ? found.contenttpl : '';
    }
  }
}
</script>

<style lang="scss" scoped>
$primary-red: #c0392b;
$hover-red: #a93226;
$primary-blue: #1a3a5c;
$bg-light: #fdf2f2; /* 党建风格的淡红背景 */
$bg-gray: #f5f8fc;
$border: #e8edf3;
$text-main: #333;
$text-secondary: #666;
$text-light: #999;

.party-page {
  overflow-x: hidden;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.bg-light {
  background-color: $bg-light !important;
}

/* ---- Banner ---- */
.page-banner {
  background-size: cover;
  background-color: $primary-red; 
  color: #fff;
  padding: 60px 0;
  position: relative;
  
  // &::before {
  //   content: '';
  //   position: absolute;
  //   top: 0; left: 0; right: 0; bottom: 0;
  //   // 党建红主题遮罩
  //   background: linear-gradient(135deg, rgba($primary-red, 0.9) 0%, rgba(#922b21, 0.9) 100%); 
  //   z-index: 1;
  // }

  .banner-single-bg, .banner-slider-bg {
    position: absolute;
    inset: 0;
    z-index: 0;
  }

  .bg-slide {
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity 0.8s ease;
    &.active { opacity: 1; }
  }

  .bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .container { position: relative; z-index: 2; }
  
  h1 { font-size: 2.2rem; font-weight: 600; margin: 0 0 15px 0; letter-spacing: 2px; }
  
  ::v-deep .el-breadcrumb__inner,
  ::v-deep .el-breadcrumb__separator { color: rgba(255, 255, 255, 0.8) !important; }
  ::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner { color: #fff !important; }
}

/* ---- 热区导航 ---- */
.party-nav {
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  transition: all 0.3s;
  z-index: 100;
  
  &.fixed {
    position: fixed;
    top: 75px; /* PC Header Height */
    left: 0;
    right: 0;
    animation: slideDown 0.3s ease-out;
  }
  
  .nav-box {
    display: flex;
    gap: 12px;
    padding: 15px 0;
    overflow-x: auto;
    
    &::-webkit-scrollbar { display: none; }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  .nav-hotspot {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 18px;
    font-size: 0.95rem;
    color: #333333;
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    text-decoration: none;
    font-weight: 500;
    white-space: nowrap;
    transition: all 0.2s ease;

    i { 
      font-size: 1.1rem; 
      color: #606266; 
      transition: color 0.2s; 
    }

    &:hover {
      background-color: #f8f9fa;
      border-color: $primary-red;
      color: $primary-red;
      i { color: $primary-red; }
    }

    &.active {
      background-color: $primary-red;
      border-color: $primary-red;
      color: #ffffff;
      font-weight: 600;

      i { color: #ffffff; }
    }
  }
}

.nav-placeholder {
  height: 66px; // 保持文档流不断开
}

@keyframes slideDown {
  from { transform: translateY(-100%); }
  to { transform: translateY(0); }
}

/* ---- 通用栏目区块 ---- */
.party-section {
  padding: 60px 0;
  background: #fff;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 35px;
  border-bottom: 2px solid $border;
  padding-bottom: 15px;

  .section-title {
    margin: 0;
    font-size: 1.8rem;
    color: $primary-red;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -17px;
      width: 60px;
      height: 3px;
      background: $primary-red;
    }
  }

  .view-more {
    color: $text-secondary;
    text-decoration: none;
    font-size: 0.95rem;
    transition: color 0.2s;
    &:hover { color: $primary-red; }
  }
}

/* ---- 党建概况 ---- */
.party-overview {
  .overview-content {
    display: flex;
    gap: 40px;
    align-items: center;
    overflow-x: auto; /* 允许超出时水平滚动 */

    ::v-deep {
      img {
        max-width: 100% !important;
        height: auto !important;
      }
      table {
        max-width: 100% !important;
        /* display: block; */ /* 移除以恢复表格原生渲染布局，防止出现右侧黑边 */
        overflow-x: auto;
      }
    }
  }

  .overview-text {
    flex: 1;
    p {
      font-size: 1.05rem;
      line-height: 1.8;
      color: $text-main;
      text-indent: 2em;
      margin-bottom: 20px;
      text-align: justify;
    }
  }

  .overview-image {
    width: 480px;
    height: 320px;
    flex-shrink: 0;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0,0,0,0.1);
    
    .placeholder-img {
      width: 100%; height: 100%;
      background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
      display: flex; flex-direction: column; align-items: center; justify-content: center;
      color: $text-secondary;
      i { font-size: 4rem; margin-bottom: 10px; color: #fff; }
    }
  }
}

/* ---- 党建动态 ---- */
.dynamics-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);
  gap: 30px;
}

.dynamic-card.featured {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0,0,0,0.05);
  cursor: pointer;
  transition: transform 0.3s;
  border: 1px solid #f0f0f0;
  text-decoration: none;

  .dynamic-image {
    position: relative;
    height: 280px;
    overflow: hidden;
  }

  .dynamic-content {
    padding: 25px;
    h4 { 
      font-size: 16px; 
      font-weight: 700; 
      color: #333; 
      line-height: 1.4; 
      margin-bottom: 15px; 
      &:hover { color: $primary-red !important; }
    }
    p  { 
      font-size: 14px; 
      color: #666; 
      line-height: 1.6; 
      margin-bottom: 20px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      overflow: hidden;
    }
    .dynamic-meta { 
      font-size: .85rem; 
      color: #999; 
      display: flex; 
      gap: 20px;
      i { margin-right: 5px; color: #bbb; }
    }
  }
}

.dynamic-list {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .dynamic-item {
    display: flex;
    gap: 15px;
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.03);
    cursor: pointer;
    transition: all 0.3s;
    border: 1px solid #f8f8f8;

    .dynamic-date {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-width: 40px;
      height: 60px;
      background: #c41e3a;
      border-radius: 8px;
      color: #fff;
      flex-shrink: 0;
      
      .day { 
        font-size: 20px; 
        font-weight: 700; 
        line-height: 1;
      }
      .month { 
        font-size: 12px; 
        opacity: 0.8;
        margin-top: 2px;
      }
    }

    .dynamic-info {
      flex: 1;
      min-width: 0;
      h5 { 
        font-size: 14px; 
        font-weight: 700; 
        margin-bottom: 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        a { color: #1a3a5c; text-decoration: none; &:hover { color: $primary-red !important; } }
      }
      p { 
          font-size: 12px;
          color :#666666;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          line-height: 1.4;
          max-height: 2.8em;
      }
    }
  }
}

/* ---- 党建专题 ---- */
.topics-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;

  .topic-card {

    i { font-size: 3rem; color: $primary-red; margin-bottom: 20px; transition: transform 0.1s; }
    h4 { font-size: 1.15rem; margin: 0; line-height: 1.4; }

    .topic-img {
      width: 100%;
      object-fit: cover;
      border-radius: 4px;
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 25px rgba($primary-red, 0.15);
      border-color: rgba($primary-red, 0.3);
      i { transform: scale(1.1); }
      h4 { color: $primary-red; }
    }
  }
}

/* 无缝滚动样式 */
.topics-continuous-wrap {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.topics-continuous-list {
  display: flex;
  width: max-content;
  animation: scrollContinuous 20s linear infinite;
  
  &:hover {
    animation-play-state: paused;
  }

  .scoll-group {
    display: flex;
  }

  .topic-card {
    width: 370px;
    margin-right: 25px;
    flex-shrink: 0;
  }
}

@keyframes scrollContinuous {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

/* ---- 党规党章 ---- */
.rules-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;

  .rule-card {
    background: #fff;
    border: 1px solid $border;
    border-radius: 8px;
    padding: 25px;
    display: flex;
    gap: 15px;
    transition: all 0.3s;

    &:hover {
      box-shadow: 0 5px 15px rgba(0,0,0,0.08);
      border-color: $primary-red;
      .btn-rule-view { background: $primary-red; color: #fff !important; }
    }

    .rule-icon {
      font-size: 2rem; color: #daaa71; /* 金色徽章感 */
      flex-shrink: 0;
    }

    .rule-content {
      flex: 1;
      min-width: 0;

      h4 { font-size: 15px; margin: 0 0 10px 0; line-height: 1.3; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
      p { font-size: 13px; color: $text-secondary; line-height: 1.5; margin: 0 0 15px 0; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; }
      
      .btn-rule-view {
        display: inline-block;
        padding: 5px 15px;
        border: 1px solid $primary-red;
        color: $primary-red;
        border-radius: 4px;
        font-size: 0.85rem;
        text-decoration: none;
        transition: all 0.2s;
      }
    }
  }
}

/* ---- 廉洁资管 ---- */
.integrity-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  .integrity-card {
    background: #fff;
    border-radius: 8px;
    padding: 25px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    transition: all 0.3s;

    &:hover { box-shadow: 0 5px 15px rgba(0,0,0,0.08); transform: translateX(5px); }

    .integrity-card-content {
      h4 { margin: 0 0 10px 0; font-size: 15px; line-height: 1.4; a { color: $text-main; text-decoration: none; transition: color 0.2s; &:hover { color: $primary-red; } } }
      p { font-size: 13px; color: $text-secondary; line-height: 1.6; margin: 0 0 15px 0; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
    }

    .integrity-card-meta {
      display: flex; gap: 20px; font-size: 0.85rem; color: $text-light;
    }
  }
}

/* ---- 联系信息 ---- */
.contact-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.contact-card {
  background: #fff;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  text-align: center;
  transition: all 0.3s;
  border: 1px solid #f0f0f0;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 30px rgba(0,0,0,0.12);
  }

  h3 {
    font-size: 1.5rem;
    color: $primary-red;
    margin: 0 0 20px 0;
    font-weight: 600;
  }

  p {
    font-size: 0.95rem;
    color: $text-main;
    line-height: 1.6;
    margin: 10px 0;
  }

  .contact-value {
    font-size: 16px;
    color: $primary-blue;
    font-weight: 500;
    background: #f5f8fc;
    padding: 15px;
    border-radius: 8px;
    margin-top: 10px;
  }
}

/* ---- 群团工会 (New Card Grid) ---- */
.union-new-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.union-card {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0,0,0,0.06);
  text-decoration: none;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s, box-shadow 0.3s;
  border: 1px solid #f0f0f0;
  position: relative; /* For the overlay */

  &:hover { 
    transform: translateY(-5px); 
    box-shadow: 0 8px 25px rgba(0,0,0,0.12);
  }

  .union-card-image {
    width: 100%;
    height: 180px;
    background: #f5f5f5;
    overflow: hidden;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.5s;
    }
  }
.union-card-divider {
    width: 60%;
    height: 1px;
    background: linear-gradient(to right, transparent, var(--primary-color), transparent);
    margin: 0 auto 12px;
}
  .union-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.3s;
    z-index: 5;

    .btn-detail {
        background: #fff;
        color: $primary-blue;
        padding: 8px 20px;
        border-radius: 4px;
        font-size: 0.9rem;
        font-weight: 500;
        transform: translateY(10px);
        transition: all 0.3s;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    }
  }

  &:hover {
    .union-overlay {
      opacity: 1;
      .btn-detail {
        transform: translateY(0);
      }
    }
    .union-card-image img {
      transform: scale(1.08);
    }
  }

  .union-card-content {
    padding: 20px;
    flex: 1;
    display: flex;
    flex-direction: column;

    h4 {
      // font-size: 1.05rem;
      // margin: 0 0 10px 0;
      // color: #333;
      // line-height: 1.4;
      // font-weight: 600;
      // display: -webkit-box;
      // -webkit-line-clamp: 2;
      // line-clamp: 2;
      // -webkit-box-orient: vertical;
      // overflow: hidden;
      // min-height: 2.8em;
      // transition: color 0.2s;
      font-size: 14px;
      font-weight: 600;
      color: var(--text-primary);
      line-height: 1.6;
      margin-bottom: 12px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      min-height: 45px;

    }

    &:hover h4 {
      color: $primary-red;
    }

    .union-summary {
      font-size: 0.9rem;
      color: #777;
      line-height: 1.6;
      margin: 0 0 15px 0;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      flex: 1;
      height: 3.2em;
    }

    .union-meta {
      text-align: right;
      padding-top: 10px;
      border-top: 1px solid #f0f0f0;

      .union-date {
        font-size: 0.85rem;
        color: #999;
      }
    }
  }
}

/* ================== 响应式适配 ================== */

/* Pad / Desktop ( < 1100px ) */
@media (max-width: 1100px) {
  .party-overview .overview-content { flex-direction: column; }
  .party-overview .overview-image { width: 100%; height: 400px; }
  
  .dynamics-grid { grid-template-columns: minmax(0, 1fr); }
  .dynamic-card.featured, .dynamic-list { width: 100%; box-sizing: border-box; }
  
  .topics-grid, .union-new-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .rules-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

/* Mobile & Tablet ( < 1000px ) */
@media (max-width: 1000px) {
  .page-banner { padding: 30px 0; h1 { font-size: 1.6rem; } }
  
  .party-nav {
    .nav-box {
      padding: 12px 15px;
      gap: 10px;
      
      // 如果希望导航也换行展示（彻底解决滚动条问题且更易点击）可以开启下面两行
      // flex-wrap: wrap; 
      // justify-content: center;
    }

    .nav-hotspot { 
      padding: 8px 12px; 
      font-size: 0.85rem;
      gap: 4px;
      
      i { font-size: 1rem; }
    }

    &.fixed {
       top: 60px; /* Mobile Header Height */
    }
  }

  .party-overview .overview-image { height: 250px; }

  .topics-grid, .rules-grid, .integrity-grid, .union-new-grid, .contact-grid { grid-template-columns: minmax(0, 1fr); }
  
  .topics-continuous-list .topic-card {
    width: 280px;
    margin-right: 15px;
  }

  .section-header {
    margin-bottom: 25px;
    .section-title { font-size: 1.4rem; }
    .view-more { padding: 5px 0; display: inline-block; }
  }

  .dynamic-card.featured .dynamic-image { height: 200px; }
  .dynamic-card.featured .dynamic-content { padding: 15px; }
  
  .dynamic-list .dynamic-item { padding: 15px; }
  .rules-grid .rule-card { flex-direction: column; padding: 20px; }
  .rules-grid .rule-card .btn-rule-view { padding: 10px 20px; font-size: 14px; align-self: flex-start; } /* 增大移动端按钮触摸区域 */
}
</style>
